import React, { useEffect, useState } from "react";
import Icons from "../../assets/icons/index";
import Images from "../../assets/images/index";
import { Link } from "react-router-dom";
import { firebaseData } from "../../firebase";
import Loader from "../common/Loader/Loader";

export default function ContactUs(){
    const [config, setConfig] = useState();
	const [remoteLoading, setRemoteLoading] = useState(true);
    let [loader,setloader]=useState(true)

    useEffect(() => {
        const getConfigData = async () => {
            try {
                const remoteData = await firebaseData('contact_us_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setConfig(JSON.parse(remoteData));
                setloader(false)
                setRemoteLoading(false);
              } catch (error) {
                console.error('Error fetching remote data:', error);
                setRemoteLoading(false);
                setloader(false)
              }
            };
            
            if (typeof window !== 'undefined') {
                getConfigData();
            }    
        }, []);
        if (loader) {return (<><Loader/></>)}
    return(
        <div className="main_wrapper">
			<div className="breadcrumbs">
				<ul className="breadcrumb">
					<li className="breadcrumb-item"><a >Home</a></li>
					<li className="breadcrumb-item"><a >Account</a></li>
					<li className="breadcrumb-item active"><a >Contact Us</a></li>
				</ul>
			</div>
			<section className="videoLayer_wrapper account_main_wrapper contact_us_wrapper section_side_padding">
				<div className='row'>
					<div className="col-lg-8 col-md-7 col-sm-12">
						<div className="subjects_wrapper">
							<div className="setting_ttl_wrapper d-flex align-items-center">
								<figure className="sett_back_arrow">
									{
                                    <Link to={'/account'}>
									    <img src={Icons.BackArrow} alt="" className="img-fluid"/>
									</Link>
									}
								</figure>
								<div className="sett_ttl">
									<h5>Contact Us</h5>
								</div>
							</div>
							<div className="recommended_video_wrapper">
								<div className="contact_us_wrapper">
                                    <ul type="none">
                                        {
                                            config?.options?.map((obj)=>
                                            <li>
                                            <div className="contact_us_body d-flex align-items-center justify-content-between">
                                                <div className="contact_hedr">
                                                    <h6>{obj?.title}</h6>
                                                    <p>{obj?.text}</p>
                                                </div>
                                                {
                                                obj?.type=='call'&&
                                                <div className="contact_icon">
                                                    <img src={Icons.Call} alt="Call" className="img-fluid"/>
                                                </div>
                                                }
                                                {
                                                obj?.type=='whatsapp'&&
                                                <div className="contact_icon">
                                                <img src={Icons.Whatsapp} alt="Call" className="img-fluid"/>
                                                </div>
                                                }
                                                {
                                                obj?.type=='email'&&
                                                <div className="contact_icon">
                                                <img src={Icons.Msg} alt="Call" className="img-fluid"/>
                                                 </div>
                                                }
                                            </div>
                                            </li>
                                            )
                                        }
                                        {/* <li>
                                            <div className="contact_us_body d-flex align-items-center justify-content-between">
                                                <div className="contact_hedr">
                                                    <h6>Call us</h6>
                                                    <p>(+91) 981050067</p>
                                                </div>
                                                <div className="contact_icon">
                                                    <img src={Icons.Call} alt="Call" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </li>
										<li>
                                            <div className="contact_us_body d-flex align-items-center justify-content-between">
                                                <div className="contact_hedr">
                                                    <h6>Whatsapp us</h6>
                                                    <p>(+91) 981050067</p>
                                                </div>
                                                <div className="contact_icon">
                                                    <img src={Icons.Whatsapp} alt="Call" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </li>
										<li>
                                            <div className="contact_us_body d-flex align-items-center justify-content-between">
                                                <div className="contact_hedr">
                                                    <h6>email us</h6>
                                                    <p>support@egurukulapp.com</p>
                                                </div>
                                                <div className="contact_icon">
                                                    <img src={Icons.Msg} alt="Call" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </li> */}
                                    </ul>
									<div className="imp_note">
                                        <p>{config?.bottom_text}</p>
										{/* <p>Please make sure to call / email us from your registered mobile number</p> */}
									</div>
                                </div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
    )
}